module.exports = __webpack_public_path__ + "__static/site-1768578553954/img/book-pre-cover-txt.e30c142a.png";